module.exports = window.FormData



//////////////////
// WEBPACK FOOTER
// ./node_modules/isomorphic-form-data/lib/browser.js
// module id = 5938
// module chunks = 25